import React, { useState } from 'react';
import authService from '../services/authService';
import { notificationSystem } from '../utils/notifications';
import config from '../config';

const Login = ({ onLogin, onRecuperarPassword }) => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log('🔄 Enviando login request con:', { email: credentials.email, password: '***' });
      const data = await authService.login(credentials.email, credentials.password);
      
      console.log('=== RESPUESTA DEL SERVIDOR ===');
      console.log('Tipo de data:', typeof data);
      console.log('data:', data);
      console.log('data.token:', data?.token);
      console.log('data.user:', data?.user);
      console.log('=====================================');
      
      if (!data) {
        throw new Error('No se recibió respuesta del servidor');
      }
      
      if (!data.token) {
        console.error('❌ CRÍTICO: Token no existe en la respuesta');
        console.error('Contenido completo:', JSON.stringify(data, null, 2));
        throw new Error('Token no recibido del servidor');
      }
      
      console.log('✅ Token existe, guardando en localStorage...');
      localStorage.setItem(config.tokenKey, data.token);
      localStorage.setItem(config.userKey, JSON.stringify(data.user));
      
      // Verificar inmediatamente
      const verificar = localStorage.getItem(config.tokenKey);
      console.log('✅ Verificación de localStorage:', verificar ? '✅ GUARDADO' : '❌ NO GUARDADO');
      
      notificationSystem.success('Inicio de sesión exitoso');
      onLogin(data);
      
    } catch (error) {
      const serverMsg = error.response?.data?.error || error.response?.data?.message;
      const isUnauthorized = error.response?.status === 401;
      const errorMsg = serverMsg || (isUnauthorized ? 'Credenciales inválidas' : (error.message || 'Error desconocido'));

      console.error('❌ Error en login:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });

      setError(errorMsg);
      notificationSystem.error('Error: ' + errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Consultorio Psicológico</h2>
        <h3>Iniciar Sesión</h3>
        {error && <div className="error">{error}</div>}
        <input
          id="email"
          name="email"
          type="email"
          placeholder="Email"
          autoComplete="email"
          value={credentials.email}
          onChange={(e) => setCredentials({...credentials, email: e.target.value})}
          required
        />
        <input
          id="password"
          name="password"
          type="password"
          placeholder="Contraseña"
          autoComplete="current-password"
          value={credentials.password}
          onChange={(e) => setCredentials({...credentials, password: e.target.value})}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Ingresando...' : 'Ingresar'}
        </button>
        
        <div className="login-links">
          <button 
            type="button" 
            onClick={onRecuperarPassword} 
            className="link-recuperar"
            style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', textDecoration: 'underline', marginRight: '10px' }}
          >
            ¿Olvidaste tu contraseña?
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
